import React from 'react';
import { observer } from 'mobx-react';
import { Heading2, Heading3 } from '../design-system/headings';
import { useTranslation } from 'react-i18next';
import DefaultTrans from './default-i18next-trans';
import { MarkdownContent } from './MarkdownContent';

function resolveText(ui, field, t) {
    const value = ui[field];
    if (!value) return '';
    return ui.rawText ? value : t(value);
}

export const QuestionHeading = observer(({ ui }) => {
    const { t } = useTranslation('assessment');
    const useMarkdown = !!(ui.markdown || ui.rawText);

    return (
        <>
            {ui.pretitle ? (
                <Heading3 lighter mb={8}>
                    {resolveText(ui, 'pretitle', t)}
                </Heading3>
            ) : null}
            {ui.title ? (
                <Heading2 bold>{resolveText(ui, 'title', t)} </Heading2>
            ) : null}
            {ui.description ? (
                useMarkdown ? (
                    <MarkdownContent>
                        {resolveText(ui, 'description', t)}
                    </MarkdownContent>
                ) : (
                    <DefaultTrans translatedString={t(ui.description)} />
                )
            ) : (
                <p />
            )}
        </>
    );
});
